  // Helper function to get status class
  export const getStatusClass = (status) => {
    const statusClassMap = {
      "Verified Phish": "verifyText",
      "PIXM Verified": "pixmVerifiedText",
      "Reported Phish": "reportedPhishText",
    };
    return statusClassMap[status] || "unverifyText";
  };

  